const dashboardEN = {
    "view": {
        "label": {
            "allTimeSales": "All Time Sales",
            "totalToBePaid": "Total To Be Paid",
            "promoCoins": "Promo Coins",
            "promoDownloadCount": "Promo Download Count",
            "promoFeedbackCount": "Promo Feedback Count",
            "totalDownloads": "Total Downloads",
            "totalFeedbacks": "Total Feedbacks"
        },
        "options": {
            "earnings": {
              "allTime": "All Time Earnings",
              "last12Months": "Last 12 Months",
            },
            "months": {
                "jan": "Jan",
                "feb": "Feb",
                "mar": "Mar",
                "apr": "Apr",
                "may": "May",
                "jun": "Jun",
                "jul": "Jul",
                "aug": "Aug",
                "sep": "Sep",
                "oct": "Oct",
                "nov": "Nov",
                "dec": "Dec"
            },
          },
        "message": {
            "userWelcomeTitle": "Hey {{firstName}}, welcome back to Music Link Platform.",
            "ownedAndManaged": "Your account is owned and managed by <1>{{ parent_company }}</1>, visit our <3>Help Page</3> to learn more.",
            "completeInformation": "You have not submitted your information yet, please <1><strong>Complete Your Information</strong></1> to proceed further!",
            "notSubscribed": "You are not subscribed to any plan. Subscribe now to unlock the full potential of the Music Link platform!",
            "accountBlacklisted": "Your account has been blacklisted after review as we have found that the information associated with your account is linked with one of the internationally blacklisted users in our system. Consequently, we have disabled the Distribution feature for your account.",
        }
    }
};

export default dashboardEN;